import { create } from "zustand";
import dayjs, { Dayjs } from "dayjs";
import { toast } from "react-toastify";
import { calcularDiferenciaDeTiempo, completarHorasFaltantes, containsAllHorasFast, handleAxiosError, horaActualSistema, toHour, toHours } from "@/shared/utils";
import { AlertSeverityEnum, CacheKeyCalendarioENUM, Flota, IFlotaParams } from "@/shared/interfaces";
import { getFlotaAll, postHorasDisponiblesFlota, postPlanificatioUnblock, putPlanificationBlock } from "@/shared/actions/erp";
import { IFechasDisponible, IHorasDisponibles } from "@/shared/interfaces/erp/system-settings/horas-libres-flota.interface";
import { getUserSistema } from "@/shared/actions/erp/administration/usuarios";
import { useUiStore } from "@/store/ui";

type TimerStatus = "idle" | "running" | "paused" | "finished";

export enum DepartamentoSelectScheduling {
  PYL = 'PLANEACION Y LOGISTICA',
  VENTA = 'VENTA'
}

//const DEFAULT_DURATION_MS = 10 * 60 * 1000; // 10 minutos
const DEFAULT_DURATION_MS = 60 * 1000;

type defaultConfig = {
  time: number;
  tiempo: string;
  motivo: string;
  departamento: string
}

type UseSelectDateTimerPreSchedulingState = {

  handleValidDateHour: (id: number | undefined) => Promise<boolean>
  isSave: boolean
  setIsSave: (isSave: boolean) => void
  ///* valores inciales
  tiempo: string;
  motivo: string;
  departamento: string

  setConfigParams: (value: defaultConfig) => void

  ///* obtener informacion de flotas por zona 
  isLoadingFloat: boolean
  float: Flota[]
  getFloat: (params?: IFlotaParams) => void

  ///* codigo de flota
  selectFloat: string | null;
  setSelectFloat: (selectFloat: string | null) => void;

  ///* bloquear componente
  blocked: boolean

  ///* navegacion entre flotas
  currentIndex: number;
  setCurrentIndex: (currentIndex: number) => void;

  ///* obtener planificador
  isLoadingPlanner: boolean
  planner: IFechasDisponible | null
  setPlanner: (float: string) => void
  idPlanner: string | null
  slot: IHorasDisponibles | null // informacion del evento

  ///* selecionar fecha para el componente calendario
  selectDate: Dayjs
  setSelectDate: (selectDate: Dayjs) => void
  mostrarMensajeBloqueoSoftnetPorDia: (selectDate: Dayjs, selectFloat?: string | null) => Promise<void>

  ///* selecionar fecha y hora para la instalacion
  selectDateHour: string | null;

  ///* verificar planificador
  handleVerificationPlanner: (slot: IHorasDisponibles) => void
  handleConfirmedPlanner: () => void
  handleRefreshPlanner: () => void
  handleRemovePlanner: () => void
  handleCleanPlanner: () => void
  setRemovePlanner: (removePlanner: boolean) => void
  removePlanner: boolean,

  ///* renderizar modal de confirmacion
  modalConfirmBlocked: boolean
  setModalConfirmBlocked: (modalConfirmBlocked: boolean) => void
  handleCloseModalConfirmBlocked: () => void

  ///* preventa
  preventa: string | null
  setPreventa: (preventa: string | null) => void
  ///* temporizador
  durationMs: number;
  remainingMs: number;
  status: TimerStatus;
  targetEndAt: number | null;
  rafId: number | null;
  initialDurationMs: number;
  autoResetOnFinish: boolean;
  plannerRequestId: number | null;
  startTemporizer: () => void;
  resetTemporizer: (durationMs?: number) => void;
  stopAndResetTemporizer: () => void;
  restoreDefaultsTemporizer: () => void;
  unblockPlanification: () => void;
}

const useSelectDateTimerPreScheduling = create<UseSelectDateTimerPreSchedulingState>((set, get) => ({

  async handleValidDateHour() {

    try {
      const {
        slot,
        selectFloat,
        selectDate,
        preventa,
        departamento,
      } = get();

      if (!selectFloat || !preventa) {
        toast.info('No existe información de flota o preventa')
        return false;
      }

      if (!slot) {
        toast.info('Seleccionar una hora de instalación')
        return false;
      }

      const day = selectDate.format('YYYY-MM-DD')

      const {
        data
      } = await postHorasDisponiblesFlota({
        flota: selectFloat!,
        limite: 1,
        incluir_expirados: true,
        fecha: day
      });

      const planificador = data.find(e => e.fecha == day)
      const horas = planificador?.horas.find(e => e.hora == slot.hora)

      if (!horas) {
        toast.info('Hora se encuentra ocupada, actualizar el planificador para ver horas disponibles.')
        return false;
      }


      // bloqueo temporal por otro persona de pyl

      const {
        fecha_hora_limite,
        estado,
        id_user
      } = horas

      if (fecha_hora_limite != null) {

        const dateLimite = dayjs(fecha_hora_limite.split(" ")[0]);
        const dateActual = dayjs().startOf("day");

        if (!dateLimite.isBefore(dateActual) && departamento.includes(DepartamentoSelectScheduling.PYL)) {

          const horaActual = horaActualSistema()
          const horaPlanificador = fecha_hora_limite.split(" ")[1]
          const seg = calcularDiferenciaDeTiempo(horaActual, horaPlanificador)

          const resp = await getUserSistema(+id_user!)

          const profile = resp?.data.profile

          if (seg > 0 && resp?.data.profile?.departamento_nombre?.includes(DepartamentoSelectScheduling.PYL) && id_user != profile?.user) {
            toast.info(`Este espacio está en uso por ${resp.data.username}. Para evitar duplicidad de datos, por favor espera un poco o actualiza el planificador.`)
            return false
          }

          /* if (seg > 0 && Number(id_user) != authId ) {
            toast.info(`Este espacio está en uso. Para evitar duplicidad de datos, por favor espera un poco o actualiza el planificador.`)
            return false
          } */
        }
      }

      ///* bloquear por planta externa 
      if (estado) {
        toast.info('El planificador fue bloqueado por otra instalación.')
        return false;
      }

      return true;
    } catch (error) {
      toast.error('Error al validar la fecha y hora')
      throw error;
    }
  },
  isSave: false,
  setIsSave: (isSave: boolean) => set({ isSave }),
  tiempo: CacheKeyCalendarioENUM.TIEMPO_LIMITE,
  motivo: CacheKeyCalendarioENUM.MENSAJE_BLOQUEO,
  departamento: DepartamentoSelectScheduling.VENTA,
  setConfigParams(data) {

    const {
      time,
      tiempo,
      motivo,
      departamento

    } = data

    set({
      initialDurationMs: time,
      durationMs: time,
      remainingMs: time,
      tiempo,
      motivo,
      departamento
    })
  },
  unblockPlanification: () => {

    const {
      slot,
      selectFloat,
      selectDate,
      isSave,
      stopAndResetTemporizer
    } = get();


    if (isSave) {
      stopAndResetTemporizer();
      return
    }

    if (!selectFloat || !slot) {
      console.log('No se puede desbloquear el planificador');
      return;
    }

    const hora = slot.hora ?? 0

    const horas = toHours(hora)

    postPlanificatioUnblock({
      fecha: selectDate.format('YYYY-MM-DD'),
      flota: selectFloat,
      horas: horas
    })

    stopAndResetTemporizer();


  },
  preventa: null,
  setPreventa(preventa) {
    set({ preventa })
  },
  removePlanner: true,
  setRemovePlanner(removePlanner) {
    set({ removePlanner })
  },
  plannerRequestId: null,
  isLoadingPlanner: false,
  idPlanner: null,
  slot: null,
  modalConfirmBlocked: false,
  setModalConfirmBlocked(modalConfirmBlocked) {
    set({ modalConfirmBlocked })
  },
  selectFloat: null,
  setSelectFloat(selectFloat) {
    set({ selectFloat })
  },
  selectDateHour: null,

  selectDate: dayjs(),
  setSelectDate(selectDate) {
    set({ selectDate })
    get().handleRefreshPlanner();

  },
  async mostrarMensajeBloqueoSoftnetPorDia(selectDate, selectFloatParam) {
    const selectFloat = selectFloatParam ?? get().selectFloat;

    if (!selectFloat || !selectDate?.isValid()) return;

    const fecha = selectDate.format("YYYY-MM-DD");

    try {
      const { data } = await postHorasDisponiblesFlota({
        flota: selectFloat,
        limite: 1,
        incluir_expirados: true,
        incluir_bloqueos_softnet: true,
        fecha,
      });

      const planificador = data.find(e => e.fecha === fecha);
      const horasSoftnet = planificador?.horas.filter(e => e.motivo?.trim().toUpperCase().startsWith("SN")) ?? [];

      if (horasSoftnet.length === 0) return;

      const grupos = horasSoftnet.reduce<Record<string, { motivo: string; usuario: string; horas: string[] }>>((acc, hora) => {
        const motivo = hora.motivo || "Sin motivo";
        const usuario = hora.historial?.at(-1)?.user || "Sin usuario";
        const key = `${motivo}|${usuario}`;

        if (!acc[key]) {
          acc[key] = {
            motivo,
            usuario,
            horas: [],
          };
        }

        acc[key].horas.push(toHour(hora.hora));
        return acc;
      }, {});

      const detalle = Object.values(grupos)
        .map(grupo => `Horarios: ${grupo.horas.join(", ")}. Motivo: ${grupo.motivo}. Usuario: ${grupo.usuario}.`)
        .join(" ");

      useUiStore.getState().setAlert(
        true,
        `Horarios bloqueados por Planta Externa. Fecha: ${fecha}. ${detalle}`,
        AlertSeverityEnum.error
      );
    } catch (error) {
      console.error("No se pudo validar bloqueo Softnet del dia:", error);
    }
  },
  float: [],
  async getFloat(params) {
    set({ isLoadingFloat: true });
    const { data } = await getFlotaAll(params!);
    set({
      float: data.data,
      isLoadingFloat: false
    });
    get().setPlanner(data.data[0].codigo);

  },
  isLoadingFloat: false,
  currentIndex: 0,
  setCurrentIndex(currentIndex) {
    set({ currentIndex })
  },

  planner: null,
  handleCleanPlanner() {

    const {
      resetTemporizer,
      handleRemovePlanner,
      removePlanner
    } = get()

    if (removePlanner) {
      handleRemovePlanner()
    }

    resetTemporizer()

  },
  async setPlanner(codFloat) {

    // renderizar fechas y horas del planificador

    const {
      selectDate,
      float,
      departamento
    } = get();

    if (!selectDate) {
      set({ planner: null, selectFloat: codFloat ?? null });
      return;
    }

    const day = selectDate.format("YYYY-MM-DD");
    const isFlota = float?.some((e: Flota) => e.codigo === codFloat);

    if (!isFlota) {
      set({ planner: null, selectFloat: codFloat ?? null });
      return;
    }

    set({ isLoadingPlanner: true });

    const reqId = Date.now();
    set({ plannerRequestId: reqId });

    try {

      // Obtener nuevo datos de planificacion
      const {
        data,
      } = await postHorasDisponiblesFlota({
        flota: codFloat,
        limite: 1,
        incluir_expirados: true,
        fecha: day
      });

      if (get().plannerRequestId !== reqId) return;

      const planificador = data.find(e => e.fecha == day)

      if (planificador) {
        // Actualiza estado
        const fecha = planificador.fecha

        // filtrar planificador por rango de hora

        let horas = [];

        console.log(departamento);

        if (departamento.includes(DepartamentoSelectScheduling.PYL)) {
          console.log('todas las horas');

          horas = planificador.horas
        } else {
          horas = planificador.horas.filter(e => e.hora < 21.5 && e.hora > 6.5)
        }

        // filtrar horas ocupadas por asesor
        const horasOcup = horas.map((element) => {

          const {
            fecha_hora_limite
          } = element

          if (!departamento.includes(DepartamentoSelectScheduling.PYL)) {
            if (fecha_hora_limite != null) {
              const dateLimite = dayjs(fecha_hora_limite.split(" ")[0]);
              const dateActual = dayjs().startOf("day");
              if (!dateLimite.isBefore(dateActual) && departamento.includes(DepartamentoSelectScheduling.VENTA)) {
                const horaActual = horaActualSistema()
                const horaPlanificador = fecha_hora_limite.split(" ")[1]
                const seg = calcularDiferenciaDeTiempo(horaActual, horaPlanificador)
                if (seg > 0) {
                  return {
                    ...element,
                    estado: true
                  }
                }
              }
            }

          }

          return element
        })

        // completar horas faltantes
        const newHoras = completarHorasFaltantes(horasOcup)

        set({
          selectFloat: codFloat,
          planner: {
            fecha,
            horas: newHoras
          }
        });
      }


    } catch (err) {
      console.error("setPlanner error:", err);
      if (get().plannerRequestId === reqId) {
        set({ planner: null, selectFloat: codFloat ?? null });
      }
    } finally {
      // Solo baja el loading si este request sigue siendo el activo
      if (get().plannerRequestId === reqId) {
        set({ isLoadingPlanner: false, plannerRequestId: null });
      }
    }

  },
  blocked: false,
  async handleVerificationPlanner(slot) {
    if (slot.estado) {
      toast.info(`Lo sentimos esta hora esta bloqueada`);
      return;
    }

    set({
      slot,
      modalConfirmBlocked: true
    })

  },
  async handleConfirmedPlanner() {

    try {

      const {
        slot,
        selectFloat,
        selectDate,
        handleRefreshPlanner,
        startTemporizer,
        preventa,
        tiempo,
        motivo,
        departamento
      } = get();


      if (!selectFloat || !preventa) {
        return
      }

      if (!slot) {
        toast.info('No existe información de slot')
        return;
      }

      const day = selectDate.format('YYYY-MM-DD')

      const {
        data
      } = await postHorasDisponiblesFlota({
        flota: selectFloat!,
        limite: 1,
        incluir_expirados: true,
        fecha: day
      });

      const planificador = data.find(e => e.fecha == day)
      const horas = planificador?.horas.find(e => e.hora == slot.hora)


      if (!horas) {
        toast.info('Hora seleccionada esta ocupada por otra instalación, volver actualizar planificador.')
        return
      }

      const isValid = containsAllHorasFast(planificador?.horas ?? [], toHours(slot.hora))

      if (!isValid) {
        toast.info('Hora no cumple las 2h30m minimo para una instalación, volver actualizar planificador')
        return
      }


      const {
        estado,
        fecha_hora_limite,
        hora
      } = horas



      ///* bloquear por planta externa 
      if (estado) {
        toast.info('Hora seleccionada esta ocupada por otra instalación, volver actualizar planificador.')
        return
      }

      ///* calcular la fecha hora limite

      if (!departamento.includes(DepartamentoSelectScheduling.PYL)) {
        if (fecha_hora_limite != null) {
          const dateLimite = dayjs(fecha_hora_limite.split(" ")[0]);
          const dateActual = dayjs().startOf("day");

          if (!dateLimite.isBefore(dateActual) && departamento.includes(DepartamentoSelectScheduling.VENTA)) {
            const horaActual = horaActualSistema()
            const horaPlanificador = fecha_hora_limite.split(" ")[1]
            const seg = calcularDiferenciaDeTiempo(horaActual, horaPlanificador)

            if (seg > 0) {
              toast.info('Este espacio está en uso. Para evitar duplicidad de datos, por favor espera un poco o actualiza el planificador.')
              return
            }
          }
        }
      }


      if (departamento.includes(DepartamentoSelectScheduling.PYL)) {
        const resp = await putPlanificationBlock({
          fecha: day,
          flota: selectFloat,
          horas: toHours(hora),
          id_preventa: preventa,
          tiempo,
          motivo,
          forzar: true
        })

        if (resp.code !== 200) return;

      }



      set({
        //idPlanner: resp.data.,
        selectDateHour: `${day} ${toHour(hora)}`,
        modalConfirmBlocked: false,
        blocked: true
      })

      startTemporizer();
      handleRefreshPlanner();

    } catch (error) {
      handleAxiosError(error)
      //toast.error(texto.error_sistema)
    }
  },

  handleRefreshPlanner() {

    const { selectFloat } = get();

    if (!selectFloat) {
      toast.info('No existe flota.')
      return;
    }
    get().setPlanner(selectFloat)
  },

  handleCloseModalConfirmBlocked() {

    set({
      modalConfirmBlocked: false,
      selectDateHour: null,
      slot: null
    })

    //get().stopAndResetTemporizer();
  },

  async handleRemovePlanner() {

    try {

      const {
        idPlanner,
        handleRefreshPlanner
      } = get();

      if (!idPlanner) {
        toast.info('No existe planificador.')
        return
      }


      handleRefreshPlanner();

    } catch (error) {
      toast.error('No existe planificador.')

    }
  },
  ///* temporizador
  initialDurationMs: DEFAULT_DURATION_MS,
  autoResetOnFinish: true,
  durationMs: DEFAULT_DURATION_MS,
  remainingMs: DEFAULT_DURATION_MS,
  status: "idle",
  targetEndAt: null,
  rafId: null,
  startTemporizer: () => {

    console.log('startTemporizer');

    const {
      status,
      remainingMs,
      durationMs,
      rafId,
      handleRefreshPlanner
    } = get();
    if (status === "running" && rafId != null) return; // evita duplicar el loop

    const baseRemaining = status === "finished" ? durationMs : remainingMs;
    set({
      status: "running",
      targetEndAt: Date.now() + baseRemaining,
      remainingMs: baseRemaining,
    });

    const loop = () => {
      const { status, targetEndAt, autoResetOnFinish } = get();
      if (status !== "running" || !targetEndAt) {
        set({ rafId: null });
        return;
      }

      const left = targetEndAt - Date.now();
      if (left <= 0) {
        // terminó
        if (autoResetOnFinish) {
          get().unblockPlanification();

          if (get().removePlanner) {
            toast.info('El tiempo ha expirado para la fecha de instalación.')
            handleRefreshPlanner();
          }
        } else {
          set({ remainingMs: 0, status: "finished", targetEndAt: null, rafId: null });
        }
        return;
      }

      set({ remainingMs: left });
      const id = requestAnimationFrame(loop);
      set({ rafId: id });
    };

    const id = requestAnimationFrame(loop);
    set({ rafId: id });
  },
  resetTemporizer: (durationMs) => {
    const { rafId } = get();
    if (rafId != null) cancelAnimationFrame(rafId);

    const dur = typeof durationMs === "number" ? durationMs : get().durationMs;
    set({
      selectDate: dayjs(),
      planner: null,
      selectDateHour: null,
      idPlanner: null,
      removePlanner: true,
      blocked: false,
      durationMs: dur,
      remainingMs: dur,
      status: "idle",
      targetEndAt: null,
      rafId: null,
    });
  },

  stopAndResetTemporizer: () => {
    const { rafId } = get();
    if (rafId != null) cancelAnimationFrame(rafId);
    const init = get().initialDurationMs;
    set({
      slot: null,
      selectDate: dayjs(),
      planner: null,
      selectDateHour: null,
      idPlanner: null,
      removePlanner: true,
      blocked: false,
      durationMs: init,
      remainingMs: init,
      status: "idle",
      targetEndAt: null,
      rafId: null,
      isSave: false
    });
  },

  restoreDefaultsTemporizer: () => {
    const { rafId, initialDurationMs } = get();
    if (rafId != null) cancelAnimationFrame(rafId);

    set({
      durationMs: initialDurationMs,
      remainingMs: initialDurationMs,
      status: "idle",
      targetEndAt: null,
      rafId: null,
    });
  },

}))

export default useSelectDateTimerPreScheduling
